module.exports = __webpack_public_path__ + "static/media/LondonMail.1e11fb77.svg";